import { createAction } from '@reduxjs/toolkit';
import { dispatch } from 'store';

export type LikeToggleActionPayload = {
  id: number;
  liked: boolean;
  searchGuid?: string;
  recommendationId?: string;
  recommendationEngine?: string;
};

export const likeToggled = createAction<LikeToggleActionPayload>('likeService/LIKE_STATE_TOGGLED');
export const likeToggledLocally = createAction<LikeToggleActionPayload>('likeService/LIKE_LOCAL_STATE_TOGGLED');

export const likeServiceActions = {
  toggleLikeState: (likedData: LikeToggleActionPayload) => dispatch(likeToggled(likedData)),
  toggleLikeLocalState: (likedData: LikeToggleActionPayload) => dispatch(likeToggledLocally(likedData)),
};
